export const tasks = [
    "Mob 3rd Party", 
    "Mob PGE", 
    "DeMob 3rd Party", 
    "DeMob PGE", 
    "3rd Party Work", 
    "PGE PM Work", 
    "Rest", 
    "Lunch",
    "Toll Charges 3rd Party", 
    "Toll Charges PGE",
    "Hotel Charges 3rd Party", 
    "Hotel Charges PGE",
    "Non Production", 
    "Non Billable", 
];
const tp = ["Mob 3rd Party", "DeMob 3rd Party", "3rd Party Work", "Toll Charges 3rd Party", "Hotel Charges 3rd Party"];
const pge = ["Mob PGE", "DeMob PGE", "PGE PM Work", "Toll Charges PGE", "Hotel Charges PGE"];
// const fieldMeet = ["3rd Party Field Meet", "PGE Field Meet"];
export const divisionList = [

    {value: "42910628_Sacramento_Trans", range: tp, tpw: true, region: "Sacramento", devision: "Sacramento", index: 1}, 
    // {value: "42910627_Sacramento_Distr_Pipe Burst", range: tp, tpw: true, region: "Sacramento", devision: "Sacramento", index: 1}, 
    // {value: "42910627_Sacramento_Distr_LP Buffer", range: tp, tpw: true, region: "Sacramento", devision: "Sacramento", index: 1}, 
    {value: "42910627_Sacramento_Distr", range: tp, tpw: true, region: "Sacramento", devision: "Sacramento", index: 1}, 
    {value: "Sacramento_PGE PM", range: pge, tpw: false, region: "Sacramento", devision: "Sacramento"},
    // {value: "42708348_Sacramento_Field Meet", range: fieldMeet, tpw: false, region: "Sacramento", devision: "Sacramento"},

    {value: "42910633_Vacaville_Trans", range: tp, tpw: true, region: "Sacramento", devision: "Vacaville", index: 2}, 
    // {value: "42910632_Vacaville_Distr_Pipe Burst", range: tp, tpw: true, region: "Sacramento", devision: "Vacaville", index: 2}, 
    // {value: "42910632_Vacaville_Distr_LP Buffer", range: tp, tpw: true, region: "Sacramento", devision: "Vacaville", index: 2}, 
    {value: "42910632_Vacaville_Distr", range: tp, tpw: true, region: "Sacramento", devision: "Vacaville", index: 2}, 
    {value: "Vacaville_PGE PM", range: pge, tpw: false, region: "Sacramento", devision: "Vacaville"},
    // {value: "42910635_Vacaville_Field Meet", range: fieldMeet, tpw: false, region: "Sacramento", devision: "Vacaville"},


    {value: "42910680_San Jose_Cinnabar_Trans", range: tp, tpw: true, region: "Southern", devision: "San Jose - Cinnabar", index: 3}, 
    // {value: "42910679_San Jose_Cinnabar_Distr_Pipe Burst", range: tp, tpw: true, region: "Southern", devision: "San Jose - Cinnabar", index: 3}, 
    // {value: "42910679_San Jose_Cinnabar_Distr_LP Buffer", range: tp, tpw: true, region: "Southern", devision: "San Jose - Cinnabar", index: 3}, 
    {value: "42910679_San Jose_Cinnabar_Distr", range: tp, tpw: true, region: "Southern", devision: "San Jose - Cinnabar", index: 3}, 
    {value: "San Jose_Cinnabar_PGE PM", range: pge, tpw: false, region: "Southern", devision: "San Jose - Cinnabar"},
    // {value: "42910681_San Jose_Cinnabar_Field Meet", range: fieldMeet, tpw: false, region: "Southern", devision: "San Jose - Cinnabar"},

    {value: "42910675_San Jose_Edenvale_Trans", range: tp, tpw: true, region: "Southern", devision: "San Jose - Edenvale", index: 4}, 
    // {value: "42910674_San Jose_Edenvale_Distr_Pipe Burst", range: tp, tpw: true, region: "Southern", devision: "San Jose - Edenvale", index: 4}, 
    // {value: "42910674_San Jose_Edenvale_Distr_LP Buffer", range: tp, tpw: true, region: "Southern", devision: "San Jose - Edenvale", index: 4}, 
    {value: "42910674_San Jose_Edenvale_Distr", range: tp, tpw: true, region: "Southern", devision: "San Jose - Edenvale", index: 4}, 
    {value: "San Jose_Edenvale_PGE PM", range: pge, tpw: false, region: "Southern", devision: "San Jose - Edenvale"},
    // {value: "42708342_San Jose_Edenvale_Field Meet", range: fieldMeet, tpw: false, region: "Southern", devision: "San Jose - Edenvale"},

    {value: "42910378_Central Coast_Trans", range: tp, tpw: true, region: "Southern", devision: "Central Coast", index: 5},  
    // {value: "42910377_Central Coast_Distr_Pipe Burst", range: tp, tpw: true, region: "Southern", devision: "Central Coast", index: 5},  
    // {value: "42910377_Central Coast_Distr_LP Buffer", range: tp, tpw: true, region: "Southern", devision: "Central Coast", index: 5},  
    {value: "42910377_Central Coast_Distr", range: tp, tpw: true, region: "Southern", devision: "Central Coast", index: 5},  
    {value: "PGE PM_Central Coast", range: pge, tpw: false, region: "Southern", devision: "Central Coast"},
    // {value: "42708356_Central Coast Field Meet", range: fieldMeet, tpw: false, region: "Southern", devision: "Central Coast"},

    {value: "42910623_Los Padres_Trans", range: tp, tpw: true, region: "Southern", devision: "Los Padres", index: 6}, 
    // {value: "42910622_Los Padres_Distr_Pipe Burst", range: tp, tpw: true, region: "Southern", devision: "Los Padres", index: 6}, 
    // {value: "42910622_Los Padres_Distr_LP Buffer", range: tp, tpw: true, region: "Southern", devision: "Los Padres", index: 6}, 
    {value: "42910622_Los Padres_Distr", range: tp, tpw: true, region: "Southern", devision: "Los Padres", index: 6}, 
    {value: "PGE PM_Los Padres", range: pge, tpw: false, region: "Southern", devision: "Los Padres"},
    // {value: "42735664_Los Padres_Field Meet", range: fieldMeet, tpw: false, region: "Southern", devision: "Los Padres"},


    {value: "42910665_East Bay_Trans", range: tp, tpw: true, region: "East Bay", devision: "East Bay", index: 7},
    // {value: "42910664_East Bay_Dist_Pipe Burst", range: tp, tpw: true, region: "East Bay", devision: "East Bay", index: 7},
    // {value: "42910664_East Bay_Distr_LP Buffer", range: tp, tpw: true, region: "East Bay", devision: "East Bay", index: 7},
    {value: "42910664_East Bay_Distr", range: tp, tpw: true, region: "East Bay", devision: "East Bay", index: 7},
    {value: "East Bay_PGE PM", range: pge, tpw: false, region: "East Bay", devision: "East Bay"},
    // {value: "42708339_East Bay_Field Meet", range: fieldMeet, tpw: false, region: "East Bay", devision: "East Bay"},

    {value: "42910660_Diablo_Trans", range: tp, tpw: true, region: "East Bay", devision: "Diablo", index: 8},
    // {value: "42910659_Diablo_Distr_Pipe Burst", range: tp, tpw: true, region: "East Bay", devision: "Diablo", index: 8},
    // {value: "42910659_Diablo_Distr_LP Buffer", range: tp, tpw: true, region: "East Bay", devision: "Diablo", index: 8},
    {value: "42910659_Diablo_Distr", range: tp, tpw: true, region: "East Bay", devision: "Diablo", index: 8},
    {value: "Diablo_PGE PM", range: pge, tpw: false, region: "East Bay", devision: "Diablo"},
    // {value: "42708338_Diablo_Field Meet", range: fieldMeet, tpw: false, region: "East Bay", devision: "Diablo"}, 


    {value: "42910640_San Francisco_Trans", range: tp, tpw: true, region: "Bay Area", devision: "San Francisco", index: 9},
    // {value: "42910639_San Francisco_Distr_Pipe Burst", range: tp, tpw: true, region: "Bay Area", devision: "San Francisco", index: 9}, 
    // {value: "42910639_San Francisco_Distr_LP Buffer", range: tp, tpw: true, region: "Bay Area", devision: "San Francisco", index: 9}, 
    {value: "42910639_San Francisco_Distr", range: tp, tpw: true, region: "Bay Area", devision: "San Francisco", index: 9}, 
    {value: "San Francisco_PGE PM", range: pge, tpw: false, region: "Bay Area", devision: "San Francisco"}, 
    // {value: "42708337_San Francisco_Field Meet", range: fieldMeet, tpw: false, region: "Bay Area", devision: "San Francisco"}, 

    {value: "42910645_Peninsula_Trans", range: tp, tpw: true, region: "Bay Area", devision: "Peninsula", index: 10}, 
    // {value: "42910644_Peninsula_Distr_Pipe Burst", range: tp, tpw: true, region: "Bay Area", devision: "Peninsula", index: 10}, 
    // {value: "42910644_Peninsula_Distr_LP Buffer", range: tp, tpw: true, region: "Bay Area", devision: "Peninsula", index: 10}, 
    {value: "42910644_Peninsula_Distr", range: tp, tpw: true, region: "Bay Area", devision: "Peninsula", index: 10}, 
    {value: "Peninsula_PGE PM", range: pge, tpw: false, region: "Bay Area", devision: "Peninsula"}, 
    // {value: "42708336_Peninsula_Field Meet", range: fieldMeet, tpw: false, region: "Bay Area", devision: "Peninsula"}, 

    {value: "42910650_De Anza_Trans", range: tp, tpw: true, region: "Bay Area", devision: "DeAnza", index: 11}, 
    // {value: "42910649_De Anza_Distr_Pipe Burst", range: tp, tpw: true, region: "Bay Area", devision: "DeAnza", index: 11}, 
    // {value: "42910649_De Anza_Distr_LP Buffer", range: tp, tpw: true, region: "Bay Area", devision: "DeAnza", index: 11}, 
    {value: "42910649_De Anza_Distr", range: tp, tpw: true, region: "Bay Area", devision: "DeAnza", index: 11}, 
    {value: "De Anza_PGE PM", range: pge, tpw: false, region: "Bay Area", devision: "DeAnza"}, 
    // {value: "42708341_De Anza_Field Meet", range: fieldMeet, tpw: false, region: "Bay Area", devision: "DeAnza"}, 


    {value: "42910716_Sonoma_Trans", range: tp, tpw: true, region: "North Bay", devision: "Sonoma", index: 12}, 
    // {value: "42910715_Sonoma_Dist_Pipe Burst", range: tp, tpw: true, region: "North Bay", devision: "Sonoma", index: 12},
    // {value: "42910715_Sonoma_Dist_LP Buffer", range: tp, tpw: true, region: "North Bay", devision: "Sonoma", index: 12},
    {value: "42910715_Sonoma_Dist", range: tp, tpw: true, region: "North Bay", devision: "Sonoma", index: 12},
    {value: "Sonoma_PGE PM", range: pge, tpw: false, region: "North Bay", devision: "Sonoma"}, 
    // {value: "42708352_Sonoma_Field Meet", range: fieldMeet, tpw: false, region: "North Bay", devision: "Sonoma"},  

    {value: "42910670_North Bay_Trans", range: tp, tpw: true, region: "North Bay", devision: "North Bay", index: 13}, 
    // {value: "42910669_North Bay_Distr_Pipe Burst", range: tp, tpw: true, region: "North Bay", devision: "North Bay", index: 13}, 
    // {value: "42910669_North Bay_Distr_LP Buffer", range: tp, tpw: true, region: "North Bay", devision: "North Bay", index: 13}, 
    {value: "42910669_North Bay_Distr", range: tp, tpw: true, region: "North Bay", devision: "North Bay", index: 13}, 
    {value: "North Bay_PGE PM", range: pge, tpw: false, region: "North Bay", devision: "North Bay"}, 
    // {value: "42708350_North Bay_Field Meet", range: fieldMeet, tpw: false, region: "North Bay", devision: "North Bay"},  


    {value: "42910722_Humboldt_Trans", range: tp, tpw: true, region: "Northern", devision: "Humbolt", index: 14}, 
    // {value: "42910721_Humboldt_Distr_Pipe Burst", range: tp, tpw: true, region: "Northern", devision: "Humbolt", index: 14}, 
    // {value: "42910721_Humboldt_Distr_LP Buffer", range: tp, tpw: true, region: "Northern", devision: "Humbolt", index: 14}, 
    {value: "42910721_Humboldt_Distr", range: tp, tpw: true, region: "Northern", devision: "Humbolt", index: 14}, 
    {value: "Humboldt_PGE PM", range: pge, tpw: false, region: "Northern", devision: "Humbolt"}, 
    // {value: "42708351_Humbolt_Field Meet",range: fieldMeet, tpw: false, region: "Northern", devision: "Humbolt"},  

    {value: "42910711_North Valley_Trans", range: tp, tpw: true, region: "Northern", devision: "North Valley", index: 15}, 
    // {value: "42910710_North Valley_Distr_Pipe Burst", range: tp, tpw: true, region: "Northern", devision: "North Valley", index: 15}, 
    // {value: "42910710_North Valley_Distr_LP Buffer", range: tp, tpw: true, region: "Northern", devision: "North Valley", index: 15}, 
    {value: "42910710_North Valley_Distr", range: tp, tpw: true, region: "Northern", devision: "North Valley", index: 15}, 
    {value: "North Valley_PGE PM", range: pge, tpw: false, region: "Northern", devision: "North Valley"}, 
    // {value: "42708347_North Valley_Field Meet", range: fieldMeet, tpw: false, region: "Northern", devision: "North Valley"},  

    {value: "42910706_Sierra_Trans", range: tp, tpw: true, region: "Northern", devision: "Sierra", index: 16}, 
    // {value: "42910705_Sierra_Distr_Pipe Burst", range: tp, tpw: true, region: "Northern", devision: "Sierra", index: 16}, 
    // {value: "42910705_Sierra_Distr_LP Buffer", range: tp, tpw: true, region: "Northern", devision: "Sierra", index: 16}, 
    {value: "42910705_Sierra_Distr", range: tp, tpw: true, region: "Northern", devision: "Sierra", index: 16}, 
    {value: "Sierra_PGE PM", range: pge, tpw: false, region: "Northern", devision: "Sierra"}, 
    // {value: "42708349_Sierra_Field Meet", range: fieldMeet, tpw: false, region: "Northern", devision: "Sierra"},  
 

    {value: "42910696_Stockton_Trans", range: tp, tpw: true, region: "Central", devision: "Stockton", index: 17}, 
    // {value: "42910695_Stockton_Distr_Pipe Burst", range: tp, tpw: true, region: "Central", devision: "Stockton", index: 17}, 
    // {value: "42910695_Stockton_Distr_LP Buffer", range: tp, tpw: true, region: "Central", devision: "Stockton", index: 17}, 
    {value: "42910695_Stockton_Distr", range: tp, tpw: true, region: "Central", devision: "Stockton", index: 17}, 
    {value: "Stockton_PGE PM", range: pge, tpw: false, region: "Central", devision: "Stockton"},
    // {value: "42708345_Stockton_Field Meet", range: fieldMeet, tpw: false, region: "Central", devision: "Stockton"},  

    {value: "42910655_Mission_Trans", range: tp, tpw: true, region: "Central", devision: "Mission", index: 18}, 
    // {value: "42910654_Mission_Distr_Pipe Burst", range: tp, tpw: true, region: "Central", devision: "Mission", index: 18}, 
    // {value: "42910654_Mission_Distr_LP Buffer", range: tp, tpw: true, region: "Central", devision: "Mission", index: 18}, 
    {value: "42910654_Mission_Distr", range: tp, tpw: true, region: "Central", devision: "Mission", index: 18}, 
    {value: "Mission_PGE PM", range: pge, tpw: false, region: "Central", devision: "Mission"},
    // {value: "42708340_Mission_Field Meet", range: fieldMeet, tpw: false, region: "Central", devision: "Mission"},  

    
    {value: "42910686_Fresno_Trans", range: tp, tpw: true, region: "Central Valley", devision: "Fresno", index: 20}, 
    // {value: "42910685_Fresno_Distr_Pipe Burst", range: tp, tpw: true, region: "Central Valley", devision: "Fresno", index: 20}, 
    // {value: "42910685_Fresno_Distr_LP Buffer", range: tp, tpw: true, region: "Central Valley", devision: "Fresno", index: 20}, 
    {value: "42910685_Fresno_Distr", range: tp, tpw: true, region: "Central Valley", devision: "Fresno", index: 20}, 
    {value: "Fresno_PGE PM", range: pge, tpw: false, region: "Central Valley", devision: "Fresno"},
    // {value: "42708343_Fresno_Field Meet", range: fieldMeet, tpw: false, region: "Central Valley", devision: "Fresno"},  

    {value: "42910701_Yosemite_Trans", range: tp, tpw: true, region: "Central Valley", devision: "Yosemite", index: 21}, 
    // {value:  "42910700_Yosemite_Distr_Pipe Burst", range: tp, tpw: true, region: "Central Valley", devision: "Yosemite", index: 21},
    // {value: "42910700_Yosemite_Distr_LP Buffer", range: tp, tpw: true, region: "Central Valley", devision: "Yosemite", index: 21},
    {value: "42910700_Yosemite_Distr", range: tp, tpw: true, region: "Central Valley", devision: "Yosemite", index: 21},
    {value: "Yosemite_PGE PM", range: pge, tpw: false, region: "Central Valley", devision: "Yosemite"},
    // {value: "42708346_Yosemite_Field Meet", range: fieldMeet, tpw: false, region: "Central Valley", devision: "Yosemite"},  

    {value: "42910691_Kern_Trans", range: tp, tpw: true, region: "Central Valley", devision: "Kern", index: 22}, 
    // {value: "42910690_Kern_Distr_Pipe Burst", range: tp, tpw: true, region: "Central Valley", devision: "Kern", index: 22}, 
    // {value: "42910690_Kern_Distr_LP Buffer", range: tp, tpw: true, region: "Central Valley", devision: "Kern", index: 22}, 
    {value: "42910690_Kern_Distr", range: tp, tpw: true, region: "Central Valley", devision: "Kern", index: 22}, 
    {value: "Kern_PGE PM", range: pge, tpw: false, region: "Central Valley", devision: "Kern"},
    // {value: "42708344_Kern_Field Meet", range: fieldMeet, tpw: false, region: "Central Valley", devision: "Kern"},  


    // {value: "2055506_Non Prod Contractor Time_Calibration_Mob", range: ["Non Production"], tpw: false},
    // {value: "2055506_Non Prod Contractor Time_Calibration_De Mob", range: ["Non Production"], tpw: false},
    // {value: "2055506_Non Prod Contractor Time_WBT", range: ["Non Production"], tpw: false},
    // {value: "2055506_Non Prod Contractor Time_Other", range: ["Non Production"], tpw: false},
    {value: "2057425_NON PROD_WBT_Safety Meet_etc.", range: ["Non Production"], tpw: false},
    {value: "2052285_Digital Catalyst Down Time", range: ["Non Production"], tpw: false},

    {value: "Non Billable_Calibration", range: ["Non Billable"], tpw: false},
    {value: "Non Billable_Other_Explain in Notes", range: ["Non Billable"], tpw: false},
    
    // {value: "2052285_LOCATE APP TROUBLE", range: ["Locate App Trouble"], tpw: false},
];
export const divisonMap = {
    //Sacramento
    "Sacramento": [
        "42910628_Sacramento_Trans", 
        // "42910627_Sacramento_Distr_Pipe Burst", 
        // "42910627_Sacramento_Distr_LP Buffer", 
        "42910627_Sacramento_Distr", 
        "Sacramento_PGE PM"
    ],
    "Vacaville": [
        "42910633_Vacaville_Trans", 
        // "42910632_Vacaville_Distr_Pipe Burst", 
        // "42910632_Vacaville_Distr_LP Buffer", 
        "42910632_Vacaville_Distr", 
        "Vacaville_PGE PM"
    ],
    //Southern
    "San Jose - Cinnabar": [
        "42910680_San Jose_Cinnabar_Trans",
        // "42910679_San Jose_Cinnabar_Distr_Pipe Burst",
        // "42910679_San Jose_Cinnabar_Distr_LP Buffer",
        "42910679_San Jose_Cinnabar_Distr",
        "San Jose_Cinnabar_PGE PM"
    ],
    "San Jose - Edenvale": [
        "42910675_San Jose_Edenvale_Trans",
        // "42910674_San Jose_Edenvale_Distr_Pipe Burst",
        // "42910674_San Jose_Edenvale_Distr_LP Buffer",
        "42910674_San Jose_Edenvale_Distr",
        "San Jose_Edenvale_PGE PM"
    ],
    "Central Coast": [
        "42910378_Central Coast_Trans",
        // "42910377_Central Coast_Distr_Pipe Burst",
        // "42910377_Central Coast_Distr_LP Buffer",
        "42910377_Central Coast_Distr",
        "PGE PM_Central Coast",
    ],
    "Los Padres": [
        "42910623_Los Padres_Trans",
        // "42910622_Los Padres_Distr_Pipe Burst",
        // "42910622_Los Padres_Distr_LP Buffer",
        "42910622_Los Padres_Distr",
        "PGE PM_Los Padres"
    ],
    //East Bay
    "East Bay": [
        "42910665_East Bay_Trans", 
        // "42910664_East Bay_Dist_Pipe Burst", 
        // "42910664_East Bay_Distr_LP Buffer", 
        "42910664_East Bay_Distr", 
        "East Bay_PGE PM"
    ],
    "Diablo": [
        "42910660_Diablo_Trans", 
        // "42910659_Diablo_Distr_Pipe Burst", 
        // "42910659_Diablo_Distr_LP Buffer", 
        "42910659_Diablo_Distr", 
        "Diablo_PGE PM"
    ],
    //Bay Area
    "San Francisco": [
        "42910640_San Francisco_Trans", 
        // "42910639_San Francisco_Distr_Pipe Burst", 
        // "42910639_San Francisco_Distr_LP Buffer", 
        "42910639_San Francisco_Distr", 
        "San Francisco_PGE PM"
    ],
    "Peninsula": [
        "42910645_Peninsula_Trans", 
        // "42910644_Peninsula_Distr_Pipe Burst", 
        // "42910644_Peninsula_Distr_LP Buffer", 
        "42910644_Peninsula_Distr", 
        "Peninsula_PGE PM"
    ],
    "DeAnza": [
        "42910650_De Anza_Trans", 
        // "42910649_De Anza_Distr_Pipe Burst", 
        // "42910649_De Anza_Distr_LP Buffer", 
        "42910649_De Anza_Distr", 
        "De Anza_PGE PM"
    ],
    //North Bay
    "Sonoma": [
        "42910716_Sonoma_Trans", 
        // "42910715_Sonoma_Dist_Pipe Burst", 
        // "42910715_Sonoma_Dist_LP Buffer", 
        "42910715_Sonoma_Dist", 
        "Sonoma_PGE PM"
    ],
    "North Bay": [
        "42910670_North Bay_Trans", 
        // "42910669_North Bay_Distr_Pipe Burst", 
        // "42910669_North Bay_Distr_LP Buffer", 
        "42910669_North Bay_Distr", 
        "North Bay_PGE PM"
    ],
    //Northern
    "Humboldt": [
        "42910722_Humboldt_Trans",
        // "42910721_Humboldt_Distr_Pipe Burst",
        // "42910721_Humboldt_Distr_LP Buffer",
        "42910721_Humboldt_Distr",
        "Humboldt_PGE PM"
    ],
    "North Valley": [
        "42910711_North Valley_Trans", 
        // "42910710_North Valley_Distr_Pipe Burst", 
        // "42910710_North Valley_Distr_LP Buffer", 
        "42910710_North Valley_Distr", 
        "North Valley_PGE PM"
    ],
    "Serra": [
        "42910706_Sierra_Trans", 
        // "42910705_Sierra_Distr_Pipe Burst", 
        // "42910705_Sierra_Distr_LP Buffer", 
        "42910705_Sierra_Distr", 
        "Sierra_PGE PM"
    ],
    //Central
    "Stockton": [
        "42910696_Stockton_Trans", 
        // "42910695_Stockton_Distr_Pipe Burst", 
        // "42910695_Stockton_Distr_LP Buffer", 
        "42910695_Stockton_Distr", 
        "Stockton_PGE PM"
    ],
    "Mission": [
        "42910655_Mission_Trans", 
        // "42910654_Mission_Distr_Pipe Burst", 
        // "42910654_Mission_Distr_LP Buffer", 
        "42910654_Mission_Distr", 
        "Mission_PGE PM"
    ],
    //Central Valley
    "Fresno": [
        "42910686_Fresno_Trans",
        // "42910685_Fresno_Distr_Pipe Burst",
        // "42910685_Fresno_Distr_LP Buffer",
        "42910685_Fresno_Distr",
        "Fresno_PGE PM"
    ],
    "Yosemite": [
        "42910701_Yosemite_Trans", 
        // "42910700_Yosemite_Distr_Pipe Burst", 
        // "42910700_Yosemite_Distr_LP Buffer", 
        "42910700_Yosemite_Distr", 
        "Yosemite_PGE PM"
    ],
    "Kern": [
        "42910691_Kern_Trans",
        // "42910690_Kern_Distr_Pipe Burst",
        // "42910690_Kern_Distr_LP Buffer",
        "42910690_Kern_Distr",
        "Kern_PGE PM"
    ]
} 